import { formatDate } from "../../../../_src_shared/utils/functions/formatDate";
import { formatPhone } from "../../../../_src_shared/utils/functions/formatPhone";
import { formatDateShort } from "../../../../utils/dates/formatDateShort";
import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";
import PdfSection from "../../pdfBuilder/components/layout/PdfSection";
import PdfSectionTitle from "../../pdfBuilder/components/typography/PdfSectionTitle";
import PdfPageBrandedSubmission from "../../pdfBuilder/pages/PdfPageBrandedSubmission";
import PDfBuilderSectionUploadedDocuments from "../../pdfBuilder/ui/sections/PDfBuilderSectionUploadedDocuments";

const PdfPageCreditAuthBorrowerInfo = ({ formData }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={"2 of 3"}
      pageTitle={"Borrower Information"}
      submittedBy={`${formData?.firstName} ${formData?.lastName}`}
      submittedDate={formData?.submission_date}
    >
      <PdfSection>
        <PdfSectionTitle>Personal Details</PdfSectionTitle>

        <PdfBuilderDataItemRow
          label={"First Name:"}
          value={formData?.firstName}
        />

        <PdfBuilderDataItemRow
          label={"Last Name:"}
          value={formData?.lastName}
        />

        <PdfBuilderDataItemRow
          label={"Phone:"}
          value={formatPhone(formData?.phone)}
        />

        <PdfBuilderDataItemRow
          label={"Email:"}
          value={formData?.emailAddress}
        />

        <PdfBuilderDataItemRow
          label={"Date of Birth:"}
          // value={formatDateShort(formData?.dateOfBirth)}
          value={formatDate(formData?.dateOfBirth)}
        />

        <PdfBuilderDataItemRow
          label={"Citizenship Status:"}
          value={formData?.citizenshipStatus}
        />

        {formData.primaryAddress && (
          <PdfBuilderDataItemRow
            label={"Primary Address:"}
            value={formData?.primaryAddress?.fullAddress}
          />
        )}

        {formData.nonUSborrowerAddress && (
          <PdfBuilderDataItemRow
            label={"Non-US Address:"}
            value={formData?.nonUSborrowerAddress}
          />
        )}

        <PdfBuilderDataItemRow
          label={"Marital Status:"}
          value={formData?.maritalStatus}
        />
        <PdfBuilderDataItemRow
          label={"SSN:"}
          type={"ssn"}
          value={formData?.borrowerSSN}
        />
      </PdfSection>

      <PDfBuilderSectionUploadedDocuments documents={formData?.documents} />
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageCreditAuthBorrowerInfo;
